import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useCallback,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnTree from "@shared/components/GridV2/SnTree";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnButton from "@shared/components/SnButton";
import { menuInfo } from "@shared/type/CommonType";
import SnAgTree from "@shared/components/Grid/SnTree";
import SN_PRD_BAS_REP_003_POP_01 from "./SN_PRD_BAS_REP_003_POP_01";
import { showPopupModal } from "@widgets/CommonModal";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_BAS_REP_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    tree: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    tree: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    tree: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          tree: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      if (searchRef.current.getFormdata().cd_item == "") {
        await showDialog("alter", "품목을 선택해 주세요.");
        return;
      }
      const param = {
        id: "sn_prd_bas_rep_003_01",
        params: searchRef.current.getFormdata(),
      };
      gridRefs.current["tree"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources({
        tree: data[0] || [],
      });
    } catch (error) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onGridBtnsClick = async (id: string) => {
    const api = gridRefs.current["tree"].current;
    if (!api) return;
    if (id === "btnOpen") {
      api.setExpandedAll(true);
    }
    if (id === "btnClose") {
      api.setExpandedAll(false);
    }

    if (id === "btnChange") {
      const displayedNodes =
        gridRefs.current["tree"].current.getDisplayedRowAtIndex();
      if (displayedNodes === 0) {
        await showDialog("alter", "전개된 건이 없습니다.");
        return;
      }
      const rowsData: any[] = [];
      api.forEachFilteredNode((node: any) => {
        if (node?.data?.no_level === 1) {
          rowsData.push(node.data);
        }
      });

      const component = <SN_PRD_BAS_REP_003_POP_01 rowData={rowsData} />;
      //{ title: "매출적용", children: component, height: "300px" }
      const result = await showPopupModal({
        title: "자재일괄변경",
        children: component,
        okayBtn: false,
      });
      if (result && result.success) {
        const param = {
          ...searchRef.current.getFormdata(),
          cd_item: result.cd_matl,
        };
        setFormData(param);
        await new Promise((resolve) => setTimeout(resolve, 50));
        onSearch();
      }
    }
  };

  const autoGroupColumnDef = {
    headerName: "모품목코드", // 그룹 컬럼의 헤더 이름
    field: "cd_parent", // 데이터를 표시할 필드
    // flex: 1,
    width: 300,
    editable: false,
    rowDrag: false, // 드래그가 가능하도록 설정
    cellRendererParams: {
      suppressCount: true, // 하위 아이템 개수 숨기기
      suppressDoubleClickExpand: true, // 더블 클릭으로 확장/축소 비활성화
      suppressHoverHighlight: false,
      //   innerRenderer: (p: any) => {
      //     return "@" + p.value;
      //   },
    },
  };

  const getRowId = useCallback(
    (params: any) => String(params.data.cd_level),
    []
  );

  //icons
  // const gridOptions = {
  //   // icons: {
  //   //   groupExpanded: "🔽",
  //   //   groupContracted: "▶️",
  //   // },
  //   // columnDefs: [
  //   //   {
  //   //     filed: "cd_parent",
  //   //     //colSpan: (params: any) => (params.data.cd_parent === "000011" ? 2 : 1),
  //   //     spanRows: true,
  //   //   },
  //   // ],
  //   // rowStyle: { background: "black" },
  //   cellStyle: "Blue",
  //   enableCellSpan: true,
  //   enableRowSpan: true,
  //   getRowStyle: (params: any) => {
  //     if (params.node.rowIndex % 2 === 0) {
  //       return { background: "red" };
  //     }
  //   },
  // };
  const grids = useMemo(
    () => ({
      tree: {
        columns: columns.tree,
        dataSource: dataSources.tree,
      },
    }),
    [columns, dataSources]
  );
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnTree
            ref={gridRefs.current["tree"]} // Grid Name
            columnConfig={grids.tree.columns} // 컬럼 설정 전달
            rowData={grids.tree.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "BOM정보" }}
            header={
              <div>
                <SnButton
                  text={"전체전개"}
                  onClick={() => {
                    onGridBtnsClick("btnOpen");
                  }}
                />
                <SnButton
                  text={"전체닫기"}
                  onClick={() => {
                    onGridBtnsClick("btnClose");
                  }}
                />
                <SnButton
                  text={"자재일괄변경"}
                  onClick={() => {
                    onGridBtnsClick("btnChange");
                  }}
                />
              </div>
            }
            treeProps={{
              treeDataParentIdField: "cd_plevel",
              treeIdKey: "cd_level",
              treeOrderKey: "no_level",
              groupDefaultExpanded: -1,
              autoGroupColumnDef: autoGroupColumnDef,
              getRowId: getRowId,
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_PRD_BAS_REP_003;
